module.exports = __webpack_public_path__ + "static/media/Novy_Saldorf.1a9d52f7.md";